import React, { useContext, useEffect, useRef, useState } from 'react'
import { Alert } from '../utils/Alert'
import EmployeeContext from '../utils/EmpDetails/EmployeeProvider'
import { decryptPII, encryptPII, encryptForBackend } from '../utils/encryption/aesEncryption'
import { companydetailnew, employeedetails, glUsrDataViaEmail, fetchGstTurnOverData, serviceVintage, apiAssignToCompany, fetcheEmployeeSearchDid, getSTSID } from '../services/merpservices'
import { glusr_details } from '../services/userservice'
import CryptoJS from "crypto-js";

// CSS
import '../assets/css/bootstrap-icons.css'
import '../assets/css/bootstrap.min.css'
import '../assets/css/fonts.css'
import '../assets/css/media-query.css'
import '../assets/css/style.css'
import { gaEvent } from '../utils/GoogleAnalytics/gatracking'
import { Glusr_identification_Creation } from '../services/loginIdentify'
import CustomerDetails from '../CustomerDetails/CustomerDetails'
import KnowledgeBase from '../components/KnowledgeBase/KnowledgeBase'
import VideoMeet from './VideoMeet'
import DisableReason from '../components/DisableReason/DisableReason'
import getCookie from '../utils/GetCookie/getCookie'
import getIP from '../utils/EmpDetails/getIP'
import IrateFlag from './IrateFlag';
import { maskMobileNumber } from '../utils/Misc/maskMobileNumber';
import { EmailMask} from '../utils/Misc/EmailMask';

import { AppGloabalContext, useGlobalContext } from '../context/AppGlobalContext';


export { useGlobalContext };

const SearchBar = ({handleLogout}) => {
  const employeeDetails = useContext(EmployeeContext);
  let empid = "";
  let ak = "";
  let ONum = "";
  let type = "";
  if (employeeDetails !== null) {
    empid = employeeDetails?.empid;
    ak = employeeDetails?.ak;
    ONum = employeeDetails?.ONum;
    type = employeeDetails?.type;
  }
  const [data, setData] = useState([])
  // const [searchTerm, setSearchTerm] = useState('');
  const [isVisible, setIsVisible] = useState(true);
  const [glid, setGlid] = useState('')
  const [custtype_name, setCusttype_name] = useState('')
  const [companyData, setCompanyData] = useState([])
  const [dropDownValue, setDropDownValue] = useState('')
  const [hambuger, setHamburger] = useState(false);
  const [source, setSource] = useState('');
  const [crtObjectId, setCrtObjectId] = useState('');
  const [dstPhone, setDstPhone] = useState('');
  const [ctcID, setCtcID] = useState('');
  const [turnover, setTurnover] = useState('');
  const [core_business_activity_nature, setCore_business_activity_nature] = useState('');
  const [vintage, setVintage] = useState('');
  const [showVideoMeetTooltip, setShowVideoMeetTooltip] = useState(false);
  const [phtype, setPhtype] = useState(0);
  const [custId, setCustId] = useState("");
  const [assignedGlid, setAssignedGlid] = useState("");
  const [paidFree, setPaidFree] = useState("");
  const [verticalId, setVerticalId] = useState("");
  const [gluserDisableReasons, setGluserDisableReasons] = useState();
  const [parentGlid, setParentGlid] = useState();
  const [glusrData, setGlusrData] = useState({});
  const [displayIrateFlag, setDisplayIrateFlag] = useState(false);
  const [did, setDid] = useState(null);
  const [stsId, setStsId] = useState("");


  const url = new URL(document.location.href);
const params = url.searchParams;
// ... (move all your params parsing UP here, before useState)

const [searchTerm, setSearchTerm] = useState(() => {
    const sk = decryptPII(params.get('searchkeyword'));
    const em = decryptPII(params.get('emailid'));
    const ph = decryptPII(params.get('phone'));
    if (sk) return sk;
    if (em) return em;
    if (ph) return ph;
    return '';
});

  const [isMasked, setIsMasked] = useState(() => {
  const sk = decryptPII(params.get('searchkeyword'));
  const em = decryptPII(params.get('emailid'));
  // changeURL() does a full window.location.href navigation, which remounts
  // this component — so the `masked` flag set by getGlid() (see below) must
  // be read back here to survive that reload; a `phone` param alone isn't a
  // reliable signal since a GLID/PNS lookup can also populate `phone` (the
  // resolved company's real number, for other components) while `searchTerm`
  // itself is the GLID/PNS code, not PII.
  const maskedFlag = params.get('masked') === '1';
  return !!((em && em.includes('@')) || (sk && sk.includes('@')) || maskedFlag);
});
  useEffect(() => {
    if (!glid || isTypingRef.current) return;
    const resolvedGlid = nglid ?? glid;
    setStsId("");
    getSTSID(employeeDetails?.empid, employeeDetails?.ak, resolvedGlid)
      .then(res => {
        if (res?.data?.status === 200) setStsId(res?.data?.data?.STSID ?? "");
      })
      .catch(() => {});
  }, [glid]);

  const wrapperRef = useRef(null);
  const dataFoundRef = useRef(false);
  const autoSearchDoneRef = useRef(false);
  const custyTypeFetchedRef = useRef(false);
  const isTypingRef = useRef(false);

  const emailId = decryptPII(params.get('emailid'));
  const phone = decryptPII(params.get('phone'));
  const sourceParam = params.get('source');
  const crtObjectIdParam = params.get('crtObjectId');
  const dstPhoneParam = params.get('dstPhone');
  const ctcIDParam = params.get('ctcID');
  const searchkeyword = decryptPII(params.get('searchkeyword'));
  const orginNumber = decryptPII(params.get('origNum'));
  const autoSuggest = params.get('dropdown')
  let nglid = params.get('nglid')

useEffect(() => {
    if (sourceParam) setSource(sourceParam);
    if (crtObjectIdParam) setCrtObjectId(crtObjectIdParam);
    if (dstPhoneParam) setDstPhone(dstPhoneParam);
    if (ctcIDParam) setCtcID(ctcIDParam);

    if (searchTerm !== "") {
        companySearch(empid, ak, searchTerm); // searchTerm is now correctly set from lazy init
    }

    if (autoSuggest === '1') setIsVisible(false);
}, [empid]);

  const selectDropdownValue = (value) => {
    setDropDownValue(value);
  }

  const searchFunctionalityGA = (ga) => {
    const emailPattern = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/;
    var searchType = '';
    if (dropDownValue !== "") {
      if (dropDownValue === "1") {
        searchType = 'Mobile Search';
      } else if (dropDownValue === "2") {
        searchType = 'Email Search';
      } else if (dropDownValue === "3") {
        searchType = 'Glid Search';
      } else if (dropDownValue === "4") {
        searchType = 'PNS Search';
      }
    } else {
      if (dropDownValue === "" && emailPattern.test(searchTerm)) {
        searchType = "Smart Email Search"
      } else if (ga === "GLID Search") {
        searchType = "Smart Glid Search"
      } else if (ga === "PNS Search") {
        searchType = "Smart PNS Search"
      } else if (ga === "Mobile Search") {
        searchType = 'Smart Mobile Search';
      }
    }
    gaEvent(searchType !== '' ? searchType : ga, searchType !== '' ? searchType : ga, 'Search', `empid: ${empid} | ucid: ${crtObjectIdParam}`, glid)

  }

  useEffect(() => {
    // Direct GLID lookup — only when no phone/email/searchkeyword is available.
    // When phone or searchkeyword is present, getData is tried first via the
    // searchTerm effect and companyDetails is called only on 204 (empty response).
    if (empid !== "" && nglid && !phone && !emailId && !searchkeyword) {
      companyDetails(empid, ak, nglid, 1);
    }
  }, [empid])


  const toggleVisibility = () => {
    setHamburger(!hambuger);
    setShowVideoMeetTooltip(false)
  };

  const companySearch = (empid, ak, value) => {
    setSearchTerm(value);
    dataFoundRef.current = false;
    if (value.length >= 3) {
      if (isNaN(value) && value.includes('@')) {
        var inputParam = '&email=' + encryptForBackend(value)
        getData(empid, ak, inputParam);
        setCompanyData([])
      } else if (value.length >= 7 && value.length <= 15) {
        getData(empid, ak, '&mobile=' + encryptForBackend(value), value);
        // companyDetails is NOT called here — getData already falls back to it on a 204 response
        setCompanyData([])
      } else {
        companyDetails(empid, ak, value, 1)
        setData([])
      }
    }
  };

  const glUserCreation = async (value) => {
    let number = searchTerm
    if (number.length === 12 && /^91/.test(number)) {
      number = number.slice(2)
    }
    const did = await fetchDidOfEmployee(empid, ak, phone);
    if (did === phone){
      setDid(did || null)
    }else{
      if (number.length === 10 && /^[6789]/.test(number)) {
        const ip = await getIP()
        const remoteIp = getCookie('CCIP') || ip.data?.ip;
        try {
          const res = await Glusr_identification_Creation(remoteIp, number)
          if (res.data.code === 200) {
            const data = res.data.DataCookie;
            if (value) {
              setGlid(data.glid)
            } else {
              changeURL(`&phone=${encryptPII(number)}&nglid=${data.glid}`);
            }
          }
        } catch (error) {
          console.log("Error", error)
        }
      }
    }
  }

  const searchByInput = (inputValue) => {
    if (searchTerm === '') {
      Alert("Kindly Enter correct Mobile No/Email/PNS/GLID to search");
      return
    }
    if (data.length >= 1) {
      setIsMasked(true);
      if (isNaN(inputValue)) {
        changeURL(`&emailid=${encryptPII(inputValue)}&nglid=${data[0]?.GLUSR_USR_ID}`)
        searchFunctionalityGA("Email Search")
      } else {
        changeURL(`&phone=${encryptPII(inputValue)}&nglid=${data[0]?.GLUSR_USR_ID}`);
        searchFunctionalityGA("Mobile Search");
      }
    } else if (companyData.length >= 1) {
      const glid = companyData[0]?.GLUSR_USR_ID;
      if (searchTerm === glid) {
        searchFunctionalityGA("GLID Search");
      } else {
        searchFunctionalityGA("PNS Search");
      }
      glusrDetails(ak, glid, inputValue);
    } else if (data.length === 0 && companyData.length === 0) {
      // changeURL(`&phone=${inputValue}`);
      glUserCreation()
      searchFunctionalityGA("Mobile Search");
    }
  }
  

  const fetchDidOfEmployee = async (empid, ak, keyword) => {
    try {
      if(data.length === 0 && companyData.length === 0){
        const res = await fetcheEmployeeSearchDid(empid, ak, keyword);
        if (res?.data?.status === 200) {
          const did = res?.data?.data?.queryData?.[0]?.CAMPAIGN_DID;
          setDid(did?.replace(/^\+91/, '') || null);
          return did?.replace(/^\+91/, '') || null;
        }
      }
      return null;
    } catch (error) {
      console.error("Error", error);
      return null;
    }
  };


  const getData = async (empid, ak, inputParam, rawKeyword) => {
    try {
      const res = await glUsrDataViaEmail(empid, ak, inputParam);
      if (res?.data?.status_code === 200) {
        // const result = res?.data?.data;
        let responseData = res?.data
        if (responseData?.data?.length >= 1) {
          setPhtype(1);
          dataFoundRef.current = true;
        };
        // Sorting glids based on custtype weight
        responseData.data.sort((a, b) => {
          const weightA = parseInt(a.GLUSR_USR_CUSTTYPE_WEIGHT) || 0;
          const weightB = parseInt(b.GLUSR_USR_CUSTTYPE_WEIGHT) || 0;

          return weightA - weightB;
        });
        setData(responseData.data);
        if ((phone || emailId) && !isTypingRef.current) {
          const resolvedGlid = nglid ?? responseData?.data[0]?.GLUSR_USR_ID;
          const matchedEntry = responseData.data.find(
            d => String(d.GLUSR_USR_ID) === String(nglid)
          ) ?? responseData.data[0];
          setGlid(responseData?.data[0]?.GLUSR_USR_ID)
          setCusttype_name(matchedEntry.GLUSR_USR_CUSTTYPE_NAME ?? '');
          if (!custyTypeFetchedRef.current) {
            custyTypeFetchedRef.current = true;
            custyTypeID(responseData?.data[0]?.GLUSR_USR_ID);
          }
        }
      } else if (res?.data?.status_code === 204) {
        if (!dataFoundRef.current) {
          const mobileNumber = rawKeyword ?? inputParam.split('=')[1];
          // Use nglid only when auto-loading the URL's phone param; for a fresh manual search use the typed number
          const fallbackKeyword = (nglid && mobileNumber === phone) ? nglid : mobileNumber;
          companyDetails(empid, ak, fallbackKeyword, 1);
        }
        setData([])
      }
    } catch (error) {
      console.log("Error", error)
    }
  }

  const companyDetails = async (empid, ak, keyword, custtype = 1) => {
    if (keyword) {
      try {
        const res = await companydetailnew(empid, ak, keyword);
        if (res?.data[0].status === "200") {
          const result = res?.data[0]?.data;
          if (result.length) {
            setPhtype(1);
            setCompanyData(result)
            if ((phone || emailId) && !isTypingRef.current) {
              setGlid(result[0]?.GLUSR_USR_ID)
              if (!custyTypeFetchedRef.current) {
                custyTypeFetchedRef.current = true;
                custyTypeID(result[0]?.GLUSR_USR_ID);
              }
            }
            if (custtype === 1 && !isTypingRef.current) {
              const matchedEntry = result.find(
                r => String(r.GLUSR_USR_ID) === String(nglid)
              ) ?? result[0];
              setCusttype_name(matchedEntry.CUSTTYPE_NAME ?? '');
            }
          } else {
            glUserCreation(1);
          }
        }
      } catch (error) {
        console.log("Error", error)
      }
    }
  }

  const glusrDetails = async (ak, glid, searchkeyword) => {
    try {
      const res = await glusr_details(ak, glid);
      const glusrPhNo = res?.data?.glusr_usr_ph_mobile;
      const email = res?.data?.glusr_usr_email;
      if (glusrPhNo === null) {
        if (email !== null) {
          changeURL(`&phone=&searchkeyword=${searchkeyword}&emailid=${encryptPII(email)}&nglid=${glid}`);
        } else {
          changeURL(`&phone=&searchkeyword=${searchkeyword}&nglid=${glid}`);
        }
      } else {
        changeURL(`&phone=${encryptPII(glusrPhNo)}&searchkeyword=${encryptPII(searchkeyword)}&nglid=${glid}`);
      }
    } catch (error) {
      console.log("Error", error)
    }
  }


  const changeURL = (param) => {
    const url = `?source=${source}&empid=${empid}&action=search&crtObjectId=${crtObjectId}&dstPhone=${dstPhone}&rsrch=1${param.replace(/\s/g, '')}&origNum=${encryptPII(ONum)}&ctcID=${ctcID}&dropdown=1${type ? `&type=${type}` : ''}`;
    window.location.href = url;
  }



  useEffect(() => {
    // Function to handle clicks outside of the div
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsVisible(false);
      }
    };

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup the event listener on unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const getGlid = async (glid, custtype_name, index) => {
    // This handler serves two different autosuggest lists: the phone/email
    // result list (`data`, populated only for a raw mobile-number or email
    // search — see companySearch) and the GLID/PNS/company-name list
    // (`companyData`). Only the former means `searchTerm` itself is PII that
    // needs masking — a GLID click can still end up with a `phone` param in
    // the URL below (the resolved company's real number, for other
    // components), but that's not what's displayed here, so it must not
    // trigger masking.
    const isPiiResult = searchTerm.includes('@') || data.length >= 1;
    if (isPiiResult) setIsMasked(true);
    setCusttype_name(custtype_name ?? "")
    setGlid(glid);
    //GA tracking based on auto suggested
    if (data.length >= 1) {
      searchFunctionalityGA(isNaN(searchTerm) ? "Smart Email Search" : "Smart Mobile Search");
    } else if (companyData.length >= 1) {
      searchFunctionalityGA(searchTerm === companyData[0]?.GLUSR_USR_ID ? "Smart GLID Search" : "Smart PNS Search");
    } else {
      searchFunctionalityGA("Smart Mobile Search");
    }

    try {
      const res = await glusr_details(ak, glid);
      const glusrPhNo = res?.data?.glusr_usr_ph_mobile;
      const email = res?.data?.glusr_usr_email;
      // changeURL() does a full page reload, which wipes the isMasked state set
      // above — persist the masking decision across that reload via a URL flag.
      const maskParam = isPiiResult ? '&masked=1' : '';
      if (glusrPhNo !== '' || glusrPhNo !== null) {
        if (data.length > 1) {
          if (glusrPhNo === null) {
            if (email !== null) {
              changeURL(`&emailid=${encryptPII(email)}&searchkeyword=${encryptPII(searchTerm)}&nglid=${glid}${maskParam}`); // passing nglid param in browser URL for getting disable icon
            }
          } else {
            changeURL(`&phone=${encryptPII(glusrPhNo)}&nglid=${glid}&searchkeyword=${encryptPII(searchTerm)}${maskParam}`);
          }
        } else {
          if (glusrPhNo === null) {
            if (email !== null) {
              changeURL(`&emailid=${encryptPII(email)}&searchkeyword=${encryptPII(searchTerm)}&nglid=${glid}${maskParam}`); // passing nglid param in browser URL for getting disable icon
            } else {
              changeURL(`&phone=&searchkeyword=${searchTerm}${maskParam}`);
            }
          } else {
            changeURL(`&phone=${encryptPII(glusrPhNo)}&searchkeyword=${encryptPII(searchTerm)}&nglid=${glid}${maskParam}`);
          }
        }
      }
    } catch (error) {

    }
  }

  const leftHamburger = (val) => {
    if (val === 'report') {
      window.open(`/api/data_dump`, '_blank');
    } else if (val === 'admin') {
      window.open('https://vendors.intermesh.net/Models/addRemoveCliDispositions.php')
    } else if (val === 'logout') {
      handleLogout();
      // window.location.href = 'https://vendors.intermesh.net/Controllers/inBoundCenter.php?logout=1'
    }
  }

  const gstTurnover = async (empid, ak, glid) => {
    if (ak !== "") {
      try {
        const response = await fetchGstTurnOverData(empid, ak, glid)
        if (response?.data?.status === 200) {
          if (response?.data?.Data.code === 200) {
            const gst_turnover = response?.data?.Data?.data?.values[0].shortname_turnover;
            setTurnover(gst_turnover === 'NA' ? "" : `|  ₹ ${gst_turnover}`)
            setCore_business_activity_nature(response?.data?.Data?.data?.values[0].core_business_activity_nature)
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  }

  const service_vintage = async (empid, ak, glid) => {
    if (ak !== '') {
      try {
        const response = await serviceVintage(empid, ak, glid);
        if (response?.data?.status === 200) {
          const data = response?.data?.data[0].SERVICE_VINTAGE;
          if (data) {
            const serviceVintage = data.split(" ");
            if (serviceVintage[0] !== "0") {
              setVintage(`| ${serviceVintage[0]} Y`);
            } else if (serviceVintage[2] !== "0") {
              setVintage(`| ${serviceVintage[2]} M`);
            } else {
              setVintage(`| ${serviceVintage[5]} D`);
            }
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
  }


  useEffect(() => {
    if (nglid !== '' && nglid !== null) {
      gstTurnover(empid, ak, nglid)
      service_vintage(empid, ak, nglid)
    }
  }, [ak])


  const allowed_emp_ids = ["50060", "29545", "37647", "85789", "93639", "93805", "100659", "64374", "94090", "107140", "113875"]

  const paidCustArray = [1, 2, 7, 10, 12, 13, 15, 31, 48];

  const custyTypeID = async (glid) => {
    const resolvedGlid = nglid ?? glid;
    let res = await apiAssignToCompany(resolvedGlid, 1);
    if (res?.data?.status === 200) {
      const custID = res?.data?.GLUSR_USR_CUSTTYPE_ID === "" ? 0 : res?.data?.GLUSR_USR_CUSTTYPE_ID;
      setCustId(parseInt(custID));
      setAssignedGlid(resolvedGlid);
      if (paidCustArray.includes(parseInt(custID))) {
        setPaidFree("Paid | ")
      } else {
        setPaidFree("Free | ")
      }
    }
  }

  return (
    <AppGloabalContext.Provider value={{ paidFree, setGluserDisableReasons, custId, assignedGlid, parentGlid, setParentGlid, glid, glusrData, setGlusrData, displayIrateFlag, setDisplayIrateFlag, verticalId, setVerticalId, did, stsId, setStsId }}>
    <>
      <header className='h-42'>
        <div className="container-fluid">
          <div className="main-bar">
            <div className="d-flex justify-content-between align-items-center">
              <div className="left-sec">
                <div className="input-box h-38">
                  <div className="input-group">
                    <input
                      type="text"
                      id="searchno_email"
                      className="form-control h-38"
                      placeholder="Mobile, Email, GLID or PNS"
                      aria-label="Dollar amount (with dot and two decimal places"
                      value={isMasked && searchTerm.includes('@')
                        ? EmailMask(searchTerm)
                        // The phone===searchTerm equality only means "mask" when it comes from
                        // the URL a fresh page load already carried (e.g. the caller's number
                        // pre-attached to an inbound call) — isTypingRef flips true forever on
                        // the first keystroke, so once the agent is actually typing, a coincidental
                        // digit match with that stale `phone` param must NOT trigger masking mid-entry.
                        : (isMasked || (!isTypingRef.current && phone && searchTerm === phone))
                        ? maskMobileNumber(searchTerm)
                        : searchTerm
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          if (searchTerm.includes('@')) setIsMasked(true);
                          searchByInput(searchTerm);
                        }
                      }}
                      onPaste={(e) => {
                        isTypingRef.current = true;
                        setIsMasked(false); 
                        companySearch(empid, ak, e.target.value);
                      }}
                      onChange={(e) => {
                        isTypingRef.current = true;
                        setIsMasked(false); 
                        companySearch(empid, ak, e.target.value);
                      }}
                      onClick={(e) => {
                        setHamburger(false);
                        setShowVideoMeetTooltip(false)
                        setIsVisible(true);
                      }}
                    />
                    <div className="search-result">
                      {searchTerm === "" ? (
                        ""
                      ) : data.length === 0 ? (
                        <>
                          {companyData.length === 0 ? (
                            <></>
                          ) : (
                            <div
                              className="resultbox fs-outfit"
                              style={{ display: isVisible ? "block" : "none" }}
                              ref={wrapperRef}
                            >
                              {companyData.slice(0, 3).map((data, i) => {
                                const {
                                  GLUSR_USR_COMPANYNAME,
                                  GLUSR_USR_ID,
                                  CUSTTYPE_NAME,
                                } = data;
                                return (
                                  <div
                                    key={`${GLUSR_USR_ID}{i}`}
                                    className={
                                      nglid === null || nglid === String(GLUSR_USR_ID)
                                        ? "companylist cp fw600 fs-outfit"
                                        : "companylist1 cp fw600 fs-outfit"
                                    }
                                    onClick={() => {
                                      getGlid(GLUSR_USR_ID, CUSTTYPE_NAME, i);
                                    }}
                                  >
                                    <span
                                      id="glusr_company"
                                      className={
                                        nglid === null
                                          ? "colorgreen fw500 fs-outfit"
                                          : nglid === String(GLUSR_USR_ID)
                                            ? "colorgreen fw500 fs-outfit"
                                            : "fw500 fs-outfit"
                                      }
                                    >
                                      {GLUSR_USR_COMPANYNAME} [{GLUSR_USR_ID}]
                                    </span>{" "}
                                    <br />
                                    <span id="cust_type" className="fw400">
                                      {CUSTTYPE_NAME}
                                    </span>{" "}
                                    <br />
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </>
                      ) : (
                        <div
                          className="resultbox fs-outfit"
                          style={{ display: isVisible ? "block" : "none" }}
                          ref={wrapperRef}
                        >
                          {data.slice(0, 4).map((data, i) => {
                            const {
                              GLUSR_USR_COMPANYNAME,
                              GLUSR_USR_FIRSTNAME,
                              GLUSR_USR_LASTNAME,
                              GLUSR_USR_ID,
                              GLUSR_USR_CUSTTYPE_NAME,
                              FK_PARENT_GLUSR_ID,
                            } = data;
                            const fname = GLUSR_USR_FIRSTNAME ?? "";
                            const lname = GLUSR_USR_LASTNAME ?? "";
                            return (
                              <div
                                key={GLUSR_USR_ID}
                                className={
                                  nglid === null || nglid === String(GLUSR_USR_ID)
                                    ? "companylist fs-outfit"
                                    : "companylist1"
                                }
                                onClick={() => {
                                  getGlid(
                                    GLUSR_USR_ID,
                                    GLUSR_USR_CUSTTYPE_NAME,
                                    i
                                  );
                                }}
                              >
                                <span
                                  className={
                                    nglid === null
                                      ? "colorgreen"
                                      : nglid === String(GLUSR_USR_ID)
                                        ? "colorgreen fw500"
                                        : ""
                                  }
                                >
                                  {GLUSR_USR_COMPANYNAME} [{GLUSR_USR_ID}]
                                </span>
                                <br />
                                <span className="fw400">
                                  {fname + " " + lname}
                                </span>
                                <br />
                                <span className="fw400">
                                  {GLUSR_USR_CUSTTYPE_NAME}
                                  {FK_PARENT_GLUSR_ID !== null ? (
                                    <>
                                      {" "}
                                      <br />{" "}
                                      <span
                                        className={
                                          nglid === String(GLUSR_USR_ID)
                                            ? "colorgreen fw500"
                                            : ""
                                        }
                                      >
                                        Parent({FK_PARENT_GLUSR_ID})
                                      </span>{" "}
                                    </>
                                  ) : (
                                    " "
                                  )}
                                </span>{" "}
                                <br />
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                    <span
                      className="input-group-text"
                      onClick={() => {
                        if (searchTerm.includes('@')) setIsMasked(true);
                        searchByInput(searchTerm);
                      }}
                    >
                      <i className="bi bi-search"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div className="right-sec">
                <ul>
                  <IrateFlag />
                  <li>
                    <a>
                      {gluserDisableReasons && <DisableReason disableDetails={gluserDisableReasons}/>}
                      {(phone || emailId) && `${paidFree}`}

                      {nglid ?? glid}
                      {(phone || emailId) && custtype_name && (
                        <> | <span className="custtype">{custtype_name} {turnover} {vintage}
                          <VideoMeet glid={glid} ak={ak}/>
                        </span></>
                      )}
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                    >
                      <i className="bi bi-list" onClick={() => {
                        toggleVisibility();
                      }}></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {allowed_emp_ids.includes(empid) ? (
          <div style={{ display: hambuger ? "block" : "none" }}>
            <div className="Frame1000009573 cp">
              <div
                className="reportbtn"
                onClick={() => leftHamburger("report")}
              >
                Report
                <div className="line85"></div>
              </div>
              <div
                className="adminbtn"
                onClick={() => leftHamburger("admin")}
              >
                Admin
                <div className="line85"></div>
              </div>
              <div
                className="logout-btn"
                onClick={() => leftHamburger("logout")}
              >
                Logout
              </div>
            </div>
          </div>
        ) : (
          <div style={{ display: hambuger ? "block" : "none" }}>
            <div className="Frame1000009573 cp">
              {(employeeDetails?.FK_IIL_DESIGNATION_ID != "2"  || empid === "117113" || empid === "113881" || empid === "113870") && (
                <div
                  className="reportbtn"
                  onClick={() => leftHamburger("report")}
                >
                  Report
                  <div className="line85"></div>
                </div>
              )}
              <div
                className="logout-btn"
                onClick={() => leftHamburger("logout")}
              >
                Logout
              </div>
            </div>
          </div>
        )}
      </header>
      {
        empid !== "" && ak !== "" ? (
          <>
            <CustomerDetails empid={empid} ak={ak} glid={nglid ?? glid} businessNature={core_business_activity_nature} phtype={phtype} />
          </>
        ) : (
          ""
        )
      }
      <KnowledgeBase />
    </>
    </AppGloabalContext.Provider>
  );
}

export default SearchBar
